export default __webpack_public_path__ + "static/media/office-2.508e19b3.webp";